import React, { useContext } from "react";
// import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Nav2 from "./layouts/nav/index2";
import Footer from "./layouts/Footer";
import ScrollToTop from "./layouts/ScrollToTop";
// import Main from './layouts/Main';
import WalletBar from "./layouts/WalletBar";
/// Dashboard
import TeacherDashboard from "./components/Dashboard/TeacherDashboard";
import DashboardDark from "./components/Dashboard/DashboardDark";
import ChangePassword from "./pages/ChangePassword";

//student
import Students from "./components/Student/Students";
import StudentDetail from "./components/Student/StudentDetail";

//Teacher
import Teachers from "./components/Teacher/Teachers";
import TeacherDetail from "./components/Teacher/TeacherDetail";
import StaffProfiles from "./components/StaffProfile/StaffProfiles";
// //Food

//Level
import Levels from "./components/Level/Levels";

//Faculty
import Faculties from "./components/Faculty/Faculties";

//Department
import Departments from "./components/Department/Departments";

//AcademicYear
import AcademicYears from "./components/AcademicYear/AcademicYears";

//Privilèges : Utilisateurs / Rôles / Permissions
import Users from "./components/Users/Users";
import Roles from "./components/Role/Roles";
import Permissions from "./components/Permission/Permissions";
import AdminRoute from "./components/AdminRoute";
import PermissionRoute from "../routes/PermissionRoute";

//Structure académique
import Semesters from "./components/Semester/Semesters";
import Subjects from "./components/Subject/Subjects";
import Classes from "./components/Class/Classes";
import StudentGroups from "./components/StudentGroup/StudentGroups";
import Enrollments from "./components/Enrollment/Enrollments";

//Banque de questions
import QuestionCategories from "./components/QuestionCategory/QuestionCategories";
import QuestionTypes from "./components/QuestionType/QuestionTypes";
import QuestionDifficulties from "./components/QuestionDifficulty/QuestionDifficulties";
import Questions from "./components/Question/Questions";

//Examens
import Exams from "./components/Exam/Exams";
import ExamSessions from "./components/ExamSession/ExamSessions";

//Résultats & passations
import Attempts from "./components/Attempt/Attempts";
import Results from "./components/Result/Results";

//Passation d'examen (côté étudiant)
import AvailableExams from "./components/StudentExam/AvailableExams";
import TakeExam from "./components/StudentExam/TakeExam";

//Notifications
import Notifications from "./components/Notification/Notifications";

//Statistiques
import Statistics from "./components/Statistics/Statistics";

//Journal d'audit
import AuditLogs from "./components/AuditLog/AuditLogs";

//Paramètres système
import Settings from "./components/Settings/Settings";

//Import / Export générique
import ImportExport from "./components/ImportExport/ImportExport";
import Rooms from "./components/Room/Rooms";
import Tablets from "./components/Tablet/Tablets";
import ClinicalCases from "./components/ClinicalCase/ClinicalCases";
import ReferenceValues from "./components/ReferenceValue/ReferenceValues";
import ExamIncidents from "./components/ExamIncident/ExamIncidents";
import GradeCorrectionRequests from "./components/GradeCorrectionRequest/GradeCorrectionRequests";

/// Form
import Element from "./components/Forms/Element/Element";
import Wizard from "./components/Forms/Wizard/Wizard";
import CkEditor from "./components/Forms/CkEditor/CkEditor";
import Pickers from "./components/Forms/Pickers/Pickers";
import FormValidation from "./components/Forms/FormValidation/FormValidation";

/// Pages

import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import { ThemeContext } from "../context/ThemeContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard1 from "./components/Dashboard/Dashboard1";

const Markup = () => {
  // Chaque route métier porte le même code de permission que son entrée
  // correspondante dans Menu.js (SideBar) : le menu masque le lien, cette
  // clé bloque aussi l'accès direct par URL. Une route sans `permission`
  // reste ouverte à tout compte authentifié (tableaux de bord, notifications,
  // passation d'examen, pages de démonstration du template).
  const routhPath = [
    { url: "teacher-dashboard", component: <TeacherDashboard /> },
    { url: "student", component: <Students />, permission: "STUDENT_PROFILE_LIST" },
    { url: "student/:id", component: <StudentDetail />, permission: "STUDENT_PROFILE_LIST" },
    { url: "teacher", component: <Teachers />, permission: "TEACHER_PROFILE_LIST" },
    { url: "teacher/:id", component: <TeacherDetail />, permission: "TEACHER_PROFILE_LIST" },
    { url: "staff-profiles", component: <StaffProfiles />, permission: "STAFF_PROFILE_LIST" },
    { url: "levels", component: <Levels />, permission: "LEVEL_LIST" },
    { url: "faculties", component: <Faculties />, permission: "FACULTY_LIST" },
    { url: "departments", component: <Departments />, permission: "DEPARTMENT_LIST" },
    { url: "academic-years", component: <AcademicYears />, permission: "ACADEMIC_YEAR_LIST" },
    { url: "form-element", component: <Element /> },
    { url: "form-wizard", component: <Wizard /> },
    { url: "form-ckeditor", component: <CkEditor /> },
    { url: "form-validation", component: <FormValidation /> },

    { url: "form-pickers", component: <Pickers /> },

    // Structure académique
    { url: "semesters", component: <Semesters />, permission: "SEMESTER_LIST" },
    { url: "subjects", component: <Subjects />, permission: "SUBJECT_LIST" },
    { url: "classes", component: <Classes />, permission: "CLASS_LIST" },
    { url: "student-groups", component: <StudentGroups />, permission: "STUDENT_GROUP_LIST" },
    { url: "enrollments", component: <Enrollments />, permission: "ENROLLMENT_LIST" },

    // Banque de questions
    { url: "question-categories", component: <QuestionCategories />, permission: "QUESTION_CATEGORY_LIST" },
    { url: "question-types", component: <QuestionTypes />, permission: "QUESTION_TYPE_LIST" },
    { url: "question-difficulties", component: <QuestionDifficulties />, permission: "QUESTION_DIFFICULTY_LIST" },
    { url: "questions", component: <Questions />, permission: "QUESTION_LIST" },

    // Examens
    { url: "exams", component: <Exams />, permission: "EXAM_LIST" },
    { url: "exam-sessions", component: <ExamSessions />, permission: "EXAM_SESSION_LIST" },

    // Résultats & passations
    { url: "attempts", component: <Attempts />, permission: "STUDENT_ATTEMPT_LIST" },
    { url: "results", component: <Results />, permission: "EXAM_RESULT_LIST" },

    // Passation d'examen (étudiant)
    { url: "my-exams", component: <AvailableExams />, permission: "STUDENT_ATTEMPT_START" },
    { url: "take-exam/:attemptId", component: <TakeExam />, permission: "STUDENT_ATTEMPT_START" },

    // Notifications (chaque compte gère les siennes, aucune permission requise)
    { url: "notifications", component: <Notifications /> },

    // Import / Export générique (accès filtré côté page selon les permissions
    // MODULE_IMPORT / MODULE_EXPORT de chaque entité, pas de garde de route unique)
    { url: "import-export", component: <ImportExport /> },
    { url: "rooms", component: <Rooms />, permission: "ROOM_LIST" },
    { url: "tablets", component: <Tablets />, permission: "TABLET_LIST" },

    // Cas cliniques / valeurs de référence / incidents / corrections de note
    { url: "clinical-cases", component: <ClinicalCases />, permission: "CLINICAL_CASE_LIST" },
    { url: "reference-values", component: <ReferenceValues />, permission: "REFERENCE_VALUE_LIST" },
    { url: "exam-incidents", component: <ExamIncidents />, permission: "EXAM_INCIDENT_LIST" },
    { url: "grade-correction-requests", component: <GradeCorrectionRequests />, permission: "GRADE_CORRECTION_REQUEST_LIST" },

    // Statistiques
    { url: "statistics", component: <Statistics />, permission: "STATISTIC_LIST" },

    // Journal d'audit
    { url: "audit-logs", component: <AuditLogs />, permission: "AUDIT_LOG_LIST" },

    // Paramètres système
    { url: "settings", component: <Settings />, permission: "SETTING_LIST" },
  ];
  const routhPath2 = [
    //Bootstrap
  ];

  return (
    <>
      <Routes>
        <Route path="/page-error-400" element={<Error400 />} />
        <Route path="/page-error-403" element={<Error403 />} />
        <Route path="/page-error-404" element={<Error404 />} />
        <Route path="/page-error-500" element={<Error500 />} />
        <Route path="/page-error-503" element={<Error503 />} />
        <Route path="/page-lock-screen" element={<LockScreen />} />

        {/* Routes protégées */}
        <Route element={<ProtectedRoute />}>
          <Route element={<Layout1 />}>
            <Route path="/dashboard-dark" element={<DashboardDark />} />
          </Route>
          <Route element={<Layout2 />}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard1 />} />
            <Route path="/change-password" element={<ChangePassword />} />
            {routhPath.map((data, i) =>
              data.permission ? (
                <Route key={i} element={<PermissionRoute permission={data.permission} />}>
                  <Route exact path={`/${data.url}`} element={data.component} />
                </Route>
              ) : (
                <Route
                  key={i}
                  exact
                  path={`/${data.url}`}
                  element={data.component}
                />
              )
            )}
            {/* Gestion des utilisateurs : accessible à tout compte disposant de la permission USER_LIST (ADMIN inclus, pas seulement SUPER_ADMIN) */}
            <Route element={<PermissionRoute permission="USER_LIST" />}>
              <Route exact path="/users" element={<Users />} />
            </Route>
            {/* Gestion des rôles/permissions : réservée aux comptes SUPER_ADMIN */}
            <Route element={<AdminRoute />}>
              <Route exact path="/roles" element={<Roles />} />
              <Route exact path="/permissions" element={<Permissions />} />
            </Route>
          </Route>
          <Route element={<Layout5 />}></Route>
          <Route element={<Layout6 />}>
            {routhPath2.map((data, i) => (
              <Route
                key={i}
                exact
                path={`/${data.url}`}
                element={data.component}
              />
            ))}
          </Route>
        </Route>
      </Routes>
      <ScrollToTop />
    </>
  );
};

function Layout1() {
  const { sidebariconHover } = useContext(ThemeContext);
  const sideMenu = useSelector((state) => state.sideMenu);
  let windowsize = window.innerWidth;
  // console.log(windowsize, 'size')
  return (
    <div
      id="main-wrapper"
      className={` show  ${sidebariconHover ? "iconhover-toggle" : ""} ${sideMenu ? "menu-toggle" : ""}`}
    >
      <div className={`wallet-open  ${windowsize > 1199 ? "active" : ""}`}>
        <Nav2 />
        <div
          className="content-body"
          style={{ minHeight: window.screen.height + 20 }}
        >
          {/* <div className="container-fluid"> */}
            <Outlet />
          {/* </div> */}
        </div>
        <Footer changeFooter="footer-outer" />
        <WalletBar />
      </div>
    </div>
  );
}

function Layout2() {
  const sideMenu = useSelector((state) => state.sideMenu);
  const { sidebariconHover } = useContext(ThemeContext);
  return (
    <div
      id="main-wrapper"
      className={`show ${sidebariconHover ? "iconhover-toggle" : ""} ${sideMenu ? "menu-toggle" : ""}`}
    >
      <Nav />
      <div
        className="content-body"
        style={{ minHeight: window.screen.height + 20 }}
      >
        {/* <div className="container-fluid"> */}
          <Outlet />
        {/* </div> */}
      </div>
      <Footer changeFooter="out-footer style-2" />
    </div>
  );
}

function Layout5() {
  const sideMenu = useSelector((state) => state.sideMenu);
  const { sidebariconHover } = useContext(ThemeContext);
  return (
    <div
      id="main-wrapper"
      className={`show ${sidebariconHover ? "iconhover-toggle" : ""} ${sideMenu ? "menu-toggle" : ""}`}
    >
      <Nav />
      <div className="content-body message-body mh-auto">
        {/* <div className="container-fluid mh-auto p-0"> */}
          <Outlet />
        {/* </div> */}
      </div>
    </div>
  );
}
function Layout6() {
  const sideMenu = useSelector((state) => state.sideMenu);
  const { sidebariconHover } = useContext(ThemeContext);
  return (
    <div
      id="main-wrapper"
      className={`show ${sidebariconHover ? "iconhover-toggle" : ""} ${sideMenu ? "menu-toggle" : ""}`}
    >
      <Nav />
      <div className="content-body">
        {/* <div className="container-fluid"> */}
          <Outlet />
        {/* </div> */}
      </div>
      <Footer changeFooter="out-footer style-1" />
    </div>
  );
}

export default Markup;
